// eslint-disable-next-line @typescript-eslint/unbound-method
Promise.withResolvers ?? (Promise.withResolvers = function () {
    let _resolve, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _reject;
    const promise = new Promise((resolve, reject) => {
        _resolve = resolve;
        _reject = reject;
    });
    return { promise, resolve: _resolve, reject: _reject };
});
// @ts-expect-error 2540
Symbol['dispose'] ?? (Symbol['dispose'] = Symbol('Symbol.dispose'));
// @ts-expect-error 2540
Symbol['asyncDispose'] ?? (Symbol['asyncDispose'] = Symbol('Symbol.asyncDispose'));
export {};
